import React from "react";
import { MdDeleteOutline } from "react-icons/md";
import { useDispatch } from "react-redux";
import { deleteNotification, getAllNotifications } from "../../store/slices/apiNotificationsSlice";
import DeleteModalNotification from "./DeleteModalNotification";

const TableItemsNotifications = ({ dataNotifications }) => {
  const notificationsArray = Array.isArray(dataNotifications) ? dataNotifications : [];
  const dispatch = useDispatch();

  const handleDelete = async (id) => {
    if (window.confirm("A jeni i sigurt që doni ta fshini këtë njoftim?")) {
      await dispatch(deleteNotification(id));
      dispatch(getAllNotifications());
    }
  };

  return (
    <>
      {notificationsArray.map((item, index) => (
        <tr
          key={item.id || index}
          className={`border-b ${index % 2 === 0 ? "bg-white" : "bg-gray-50"} dark:bg-gray-800 dark:border-gray-700`}
        >
          <td className="px-6 py-4 text-gray-700 dark:text-gray-300 max-w-xs break-words">
            {item.title}
          </td>
          <td className="px-6 py-4 text-gray-700 dark:text-gray-300 max-w-xs break-words">
            {item.message}
          </td>
          <td className="px-2 py-4 text-center">
            <DeleteModalNotification id={item.id} />
          </td>
        </tr>
      ))}
    </>
  );
};

export default TableItemsNotifications; 